import { PdfViewerTool } from '../../PdfViewer'

export const DocFlowMappingProcessCell = {
  AwsProcessFinishedAt: 'aws_process_finished_at',
  AwsProcessPercent: 'aws_process_percent',
  AwsProcessScheduled: 'aws_process_scheduled',
  AwsProcessStartedAt: 'aws_process_started_at',
  DocumentConstructorPhase: 'document_constructor_phase',
  HasMappingArea: 'has_mapping_area',
  HasPreMappingError: 'has_pre_mapping_error',
  HasPreSplittingError: 'has_pre_splitting_error',
  HasSplittingArea: 'has_splitting_area',
  HasUploadingResultsDuplicates: 'has_uploading_results_duplicates',
  MappingArea: 'mapping_area',
  MappingBuilding: 'mapping_building',
  MappingBuildingGroup: 'mapping_building_group',
  MappingIncludeArchived: 'mapping_include_archived',
  MappingMatchAccuracy: 'mapping_match_accuracy',
  MappingPhase: 'mapping_phase',
  MappingType: 'mapping_type',
  ResultMappedUsers: 'result_mapped_users',
  ResultPhase: 'result_phase',
  ResultSplittedDocuments: 'result_splitted_documents',
  SelectTypePhase: 'select_type_phase',
  SplittingArea: 'splitting_area',
  SplittingMatchAccuracy: 'splitting_match_accuracy',
  SplittingPhase: 'splitting_phase',
  SplittingType: 'splitting_type',
}

export const DOC_FLOW_MAPPING_GET_SELECTED_AREA_INFO_DEBOUNCE_TIME = 3000

export const DOC_FLOW_MAPPING_ACTIVE_FILE_ID_QUERY_PARAM = 'activeFile'

export const DOC_FLOW_MAPPING_PDF_VIEWER_TOOLS = [PdfViewerTool.Zoom]
